export const APP_VERSION = 'v1.3.54'
